/**
 * Checks if a string starts with a capital letter.
 */
export function startsWithCapital(str: string): boolean {
    return str.length > 0 && str[0] === str[0].toUpperCase();
}
